import React from 'react';
import './collection-item.styles.scss';
import CustomButton from '../../components/custom-button/custom-button.component';
import { connect as connectRedux } from 'react-redux';
import { addItem } from '../../redux/cart/cart.actions';

const CollectionItem = ({ item, addItem }) => {
    const { name, price, imageUrl } = item;
    return (<div className="collection-item">
        <div
            className="image"
            style={{
                backgroundImage: `url(${imageUrl})`
            }}
        />

        <div className="collection-footer">
            <span className="name">{name}</span>
            <span className="price">${price}</span>
        </div>

        <CustomButton inverted onClick={() => { addItem(item) }}>Add to cart</CustomButton>
    </div >
    );
}
const mapDispatchToProps = (dispatch) => ({
    addItem: item => dispatch(addItem(item))
})
export default connectRedux(null, mapDispatchToProps)(CollectionItem);